<template>
    <fieldset class="octopus-new-booking-fieldset m-left-4 m-right-2 mobile-no-m-left" :class="{'remove-flex' : ( viewPage || isAddInquiryPage )}" style="background-color: #ffffff">
        <div class="main_data_opj">

            <div class="row labelContainer pb-1" v-if=" !( itemType == 'inquiry' && viewPage ) && !isInquiry ">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Status</label>
                </div>
                <div class="col-md-9 col-xs-8">
                    <validation-provider v-slot="{errors}" name="Booking Status" :rules="value.bookingStatus?'required':''">
                        <div class="control-group octopus-booking-status">
                            <select-booking-status
                                v-model="value.bookingStatusId"
                                :booking_status='value.bookingStatus'
                                :to-estimate='estimateStatus'
                                :view-page='viewPage'
                                :booking-id='(allObject.event || {}).booking_id'
                                :to-gift-card='giftCardStatus'
                                :to-invoice='invoiceStatus'
                                :to-todo='todoStatus' :bookingStatuses="allObject.bookingStatus">
                            </select-booking-status>
                            <span class="text text-danger error-label">{{ errors[0] }}</span>
                        </div>
                    </validation-provider>
                </div>
            </div>
            <div class="row labelContainer pb-1 " v-if="viewPage && allObject.booking.is_change">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label" :style="isMobile?'font-size:13px':''">
                    </label>
                </div>
                <div class="col-md-9 col-xs-8" :style="isMobile?'padding-top:5%':''">
                    <div class="status_container line-height-62 " aria-hidden="true" data-toggle="tooltip" data-placement="top" title="Awaiting Office Approval">
                        <a class="btn labels" v-if="allObject.canApproveBooking" style="text-decoration:none; color:#FFF; border-radius:100px; background-color: #FF932F;" :href="allObject.approveChangesUrl">
                            Awaiting Office Approval
                        </a>
                        <div v-else>
                            <span style="border-radius:100px">Awaiting Office Approval</span>
                        </div>
                    </div>
                </div>

            </div>
            <div class="row labelContainer pb-1" v-if="itemType == 'inquiry' && viewPage">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Status</label>
                </div>
                <div class="col-md-9 col-xs-8">
                    <div class="control-group octopus-booking-status">
                        <select-inquiry-status
                            :inquiry-statuses="value.inquiryStatuses"
                            :inquiry-current-status="value.inquiryCurrentStatus"
                            :inquiry-id="value.inquiryId"
                        >
                        </select-inquiry-status>
                    </div>
                </div>
            </div>

            <div class="row labelContainer pb-1" v-if="viewPage && allObject.event && allObject.event.formatted_created">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Created</label>
                </div>
                <div class="col-md-9 col-xs-8" >
                        <span class="font-size-13">{{ allObject.event.formatted_created }}</span>
                </div>
            </div>

            <div class="row labelContainer pb-1 " v-if="viewPage && allObject.estimateParams && allObject.estimateParams.id && value.bookingStatusId ==3 ">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Quote Status </label>
                </div>
                <div class="col-md-9 col-xs-8" >
                    <span class="font-size-13">
                       <quote-status-change
                                      :estimate-id="allObject.estimateParams.id"
                                      :view-page="viewPage"
                                      :estimate-type="allObject.estimateParams.estimate_type"
                                      :booking-id="value.bookingId"
                                      :item-type="itemType"
                        >
                            </quote-status-change>
                    </span>

                </div>
            </div>

            <div class="row labelContainer pb-1" v-if="viewPage && allObject.booking && allObject.booking.convert_to_booking_duration ">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label" :style="isMobile?'font-size:13px':''">Lead Conversion Time
                    </label>
                </div>
                <div class="col-md-9 col-xs-8" :style="isMobile?'padding-top:5%':''">
                        <span class="font-size-13">{{ bookingDurationDisplay }}</span>
                </div>
            </div>


            <div class="row " :class="{'labelContainer': ( isAddInquiryPage ||  (!isInquiry && !viewPage) || itemType == 'booking' || (isInquiry && viewPage) ) }" v-if="itemType == 'booking' || (itemType == 'inquiry' )">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label" style="padding-top: 5%">Label</label>
                </div>
                <div class="col-md-9 col-xs-8" :class="{'change-form-list-in-inquiry' : isInquiry}">
                        <add-labels :booking-id="value.bookingId" :booking-labels="value.bookingLabels" :view-page="viewPage" :is-inquiry="isInquiry"
                                    :inquiry-id="value.inquiryId" :all-labels = "allObject.allLabels"></add-labels>
                </div>
            </div>

            <div class="row labelContainer pb-1" v-if="!(itemType == 'inquiry' && viewPage) && !isInquiry">
                <div class="col-md-3 col-xs-4  line-height-62">
                    <label class="octopus-new-booking-table-label"  style="padding-top: 5%">Owner</label>
                </div>
                <div class="col-md-9 col-xs-8">
                    <validation-provider v-slot="{errors}" name="Owner">
                        <div class="octopus-booking-owner">
                            <select-owners v-model="value.ownerId"
                                           :current-role="allObject.loggedUser.role_id"
                                           :current-user="allObject.loggedUser.user_id"
                                           :s3-path="allObject.s3Path"
                                           :view-page="viewPage"
                                           :from-issue-page="false"
                                           :booking-id="value.bookingId">
                            </select-owners>
                        </div>
                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                    </validation-provider>
                </div>
            </div>

            <div class="row labelContainer pb-1" :class="{'labelContainer': (!isInquiry || isAddInquiryPage )}" v-if="itemType == 'inquiry' && isInquiry">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Representative</label>
                </div>
                <div class="col-md-9 col-xs-8  " :class="{'change-form-list-in-inquiry' : isInquiry}">
                    <validation-provider v-slot="{errors}" name="Owner">
                        <div class="octopus-booking-owner":class="{'border-100' : isInquiry}">
                            <select-representative v-model="value.ownerId"
                                                   :current-role="allObject.loggedUser.role_id"
                                                   :current-user="allObject.loggedUser.user_id"
                                                   :s3-path="allObject.s3Path"
                                                   :view-page="viewPage"
                                                   :inquiry-id="value.inquiryId"
                                                   :selected-assigned-users="value.selectedAssignedUsers"
                                                   :selected-assigned-users-ids="value.selectedAssignedUsersIds"
                            >
                            </select-representative>
                        </div>
                        <span class="text text-danger error-label">{{ errors[0] }}</span>
                    </validation-provider>
                </div>
            </div>

            <div class="row labelContainer pb-1" v-if="(allObject.countTradingNames && allObject.countTradingNames > 1) || (allObject.tradingNames && allObject.tradingNames.length > 1)">

                <div class="col-md-3 col-xs-4 line-height-62" :class="{'line-height-62' : !viewPage}">
                    <label
                           :class="{'octopus-new-booking-table-label-inquiry' : isInquiry , 'octopus-new-booking-table-label' : !isInquiry , ' line-height-62-1' : (isAddBookingPage || isViewBookingPage )}">Trading Name</label>
                </div>
                <div class="col-md-9 col-xs-8 select-tradingName">

                        <select-trading-name
                            v-model='value.tradingId'
                            :view-page ='viewPage'
                            :booking-id="value.bookingId"
                            :is-inquiry="isInquiry"
                            :inquiry-id="value.inquiryId"
                            >
                        </select-trading-name>

                </div>
            </div>

            <div class="row labelContainer pb-1" v-if="allObject.company.show_inquiry_type">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label">Source</label>
                </div>
                <div class="col-md-9 col-xs-8">
                    <div>
                        <validation-provider v-slot="{errors}" name="Source" rules="required">
                            <select-source v-model="value.sourceId"
                                           :event_inquiry_type_id='(allObject.event || {}).inquiry_type_id'
                                           :source_ids='sourceIds'
                                           :view-page="viewPage"
                                           :booking-id="value.bookingId"
                                           :item-type="itemType"
                                           :inquiry-id="value.inquiryId"
                            >
                            </select-source>
                            <span class="text text-danger error-label">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>

                </div>
            </div>

            <div class="row labelContainer pb-1" v-show="signatureRemoved" v-if="viewPage">
                <div class="col-md-3 col-xs-4 line-height-62">
                    <label class="octopus-new-booking-table-label" v-if="allObject.customerSignaturesCreated">Signed on   &ensp; <img src="/pic/icons/signed.png" width="20" height="16"/> </label>
                    <label class="octopus-new-booking-table-label" v-else>Signed  &ensp;  <img src="/pic/icons/signed.png" width="20" height="16"/> </label>

                </div>
                <div class="col-md-9 col-xs-8">
                    <div>
                        <validation-provider v-slot="{errors}" name="Source" rules="required">
                            <signed-on
                                :customer-signatures-id="allObject.customerSignaturesId"
                                :signature-link="allObject.signature_link"
                                :customer-signatures-created="allObject.customerSignaturesCreated"
                                :can-see-customer-signatures="canSeeCustomerSignatures"
                                :can-remove-customer-signatures="canRemoveCustomerSignatures"
                            >
                            </signed-on>
                            <span class="text text-danger error-label">{{ errors[0] }}</span>
                        </validation-provider>
                    </div>

                </div>
            </div>
            <div v-if="itemType == 'inquiry' && isInquiry">
                <to-follow :item-type="itemType" :is-inquiry="isInquiry" :view-page="viewPage" :date-format="value.dateFormat" :item-id='value.inquiryId' :is-to-follow="value.is_to_follow" :to-follow-date='value.deferred_date'></to-follow>
            </div>

            <div v-else="!(itemType == 'inquiry' && isInquiry) && itemType == 'booking'">
                <to-follow :item-type="itemType" :is-inquiry="isInquiry" :booking-status="value.bookingStatusId" :view-page="viewPage" :date-format="value.dateFormat" :item-id='value.bookingId' :is-to-follow="value.is_to_follow" :to-follow-date='value.deferred_date'></to-follow>
            </div>

            <div v-if="value.bookingStatusId == 3">
                <expiry-date :item-type="itemType" :booking-status="value.bookingStatusId" :view-page="viewPage" :date-format="value.dateFormat" :item-id='value.bookingId' :is-expiry-date="value.expiryDateIsActive" :expiry-date-info='value.expiryDate'></expiry-date>
            </div>

                    <select-inquiry-period  v-if="itemType == 'inquiry' && isInquiry"
                        :inquiry-periods="value.inquiryPeriods"
                        :inquiry-current-period="value.periodRequired"
                        :inquiry-id="value.inquiryId"
                        :view-page="viewPage"
                    ></select-inquiry-period>

            <div class="row m-top-15" v-if="itemType == 'inquiry' && isInquiry">
                <div class="col-sm-12">


                    <question v-for="(question, index) of value.forms[0].questions"   :date-format="value.dateFormat" :time-format="value.timeFormat"
                              :key="question.id" v-model="value.forms[0].questions[index]" :services="value.services" :s3-path="value.s3Path" :view-page="viewPage" :is-inquiry="isInquiry"
                              :inquiry-id="value.inquiryId"
                    ></question>


                </div>

            </div>


        </div>
    </fieldset>

</template>

<script>

import {EventBus} from "@/events/event-bus";
import {ValidationProvider} from 'vee-validate';
import AddLabels from "../../common/components/addlabels.vue";
import SelectInquiryPeriod from "../../common/components/SelectInquiryPeriod";
import SelectRepresentative from "../../common/components/SelectRepresentative";
import ExpiryDate from "../../Forms/components/forms/ExpiryDate";
export default {
    name: "BookingBasicInfo",
    props:{
        value: {
            type: Object,
            default: () => {},
        },
        allObject: {
            type:Object
        },
        viewPage: {
            default() {
                return false
            }
        },
        isInquiry: {
            default() {
                return false
            }
        },
        itemTypeValue:false,
        canSeeCustomerSignatures:false,
        canRemoveCustomerSignatures:false,
        timeData: {
            default() {
                return [];
            }

        }
    },
    components: {
        ExpiryDate,
        SelectRepresentative,
        SelectInquiryPeriod,
        ValidationProvider,
        AddLabels

    },
    data(){
      return {
          estimateStatus: this.allObject.toEstimate ? (this.allObject.company.statuses || {}).QUOTED:{},
          invoiceStatus: this.allObject.toInvoice ? (this.allObject.company.statuses || {}).COMPLETED:{},
          giftCardStatus: this.allObject.gift_card ? (this.allObject.company.statuses || {}).GIFT_CARD:{},
          todoStatus: (this.allObject.company.statuses || {}).TO_DO ?? {},
          sourceIds: this.allObject.source_ids,
          signatureRemoved: this.allObject.customerSignaturesId,
      }
    },
    computed:{
        isMobile() {
            return this.getWidth() <= 768;
        },
        bookingDurationDisplay() {
            const duration = this.allObject.booking?.convert_to_booking_duration;
            const durationInDays = Math.floor(duration / 24);
            const reminderHrs = duration % 24;
            if (durationInDays === 0) {
                return reminderHrs + ' hrs';
            } else {
                return durationInDays + ' days and ' + reminderHrs + ' hrs';
            }
        },
        itemType() {
            if (this.itemTypeValue){
                return  this.itemTypeValue
            }
            else if (this.allObject.toEstimate){
                return 'estimate'
            }
            else if (this.allObject.toInvoice){
                return 'invoice'
            }
            else if (this.allObject.gift_card){
                return 'gift_card'
            }
            else if ((this.allObject.event || {}).booking_id){
                return 'booking'
            }
            else if ( ( (this.allObject.event || {}).inquiry_id ) || this.isInquiry){
                return 'inquiry'
            }
            else {
                return 'booking'
            }
        },
        isViewInquiryPage(){
            if( ( this.itemType == 'inquiry' || this.isInquiry ) && this.viewPage ){
                return true;
            }
            return false;
        },
        isAddInquiryPage(){
            if( ( this.itemType == 'inquiry' || this.isInquiry ) && !this.viewPage ){
                return true;
            }
            return false;
        },
        isViewBookingPage(){
            if( ( this.itemType == 'booking' ) && this.viewPage ){
                return true;
            }
            return false;
        },
        isAddBookingPage(){
            if( ( this.itemType == 'booking' ) && !this.viewPage ){
                return true;
            }
            return false;
        }
    },
    methods:{
        getWidth() {
            let xWidth = null;
            if (window.screen != null)
                xWidth = window.screen.availWidth;

            if (window.innerWidth != null)
                xWidth = window.innerWidth;

            if (document.body != null)
                xWidth = document.body.clientWidth;

            return xWidth;
        },
    },
    mounted() {
        // let vm = this;
        // alert('aa');
        // alert(vm.itemType);
        EventBus.$on('signatureRemoved', value=>{
            this.signatureRemoved = false;
        });
    }
}
</script>

<style scoped>
.line-height-62-1{
    line-height: 58px !important;
}
@media screen and (min-width: 768px) {
    .octopus-booking-owner {
        display: flex;
        align-items: center;
    }
}

.octopus-new-booking-table-label-inquiry{
    margin-top: 16px;
    //min-width: 100px;
    width: 100%;
    margin-bottom: 0;
    margin-right: 20px;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
}

.remove-flex{
    display: block !important;
}

.octopus-new-booking-table-label{
    width: 100%;
    word-break: break-all;
}
.pb-1{
    padding-bottom: 10px;
}
.select-tradingName :deep(.dropdown-input)
{
padding: 2px !important;
height: 32px;
border-radius: 12px;
}
.border-100{
    border: 1px solid #e5e6e7;
    border-radius: 100px;
    width: fit-content;
    padding:0 10px;
}
@media (max-width: 991px) {
    .border-100 {
        width: auto;
        height: 33px;
    }
}
</style>